export default __webpack_public_path__ + "static/media/299.63d43b79.png";